import { fetchUser } from "actions/user";
import RequireData from "hooks/RequireData";
import React from "react";
import { Button, ListGroup, Badge } from "react-bootstrap";
import { useDispatch } from "react-redux";
import fetchUserStatusSelector from "selectors/fetchUserStatus";
import userSelector from "selectors/user";
import styles from "./TeamUserRow.module.scss";

interface Props {
    user: sage.model.IPrivateUser;
    team: sage.model.ITeam | undefined;
}

const TeamUserRow: React.FC<Props> = ({ user, team }) => {
    const dispatch = useDispatch();

    const [currUser] = RequireData(
        userSelector,
        fetchUserStatusSelector,
        fetchUser()
    );

    const onDeletePressed = React.useCallback(() => {
        if (!team) {
            return;
        }
        dispatch({
            type: "com.sage.actions.team.IDeleteTeamMember",
            teamId: team.id,
            email: user.email,
        } as sage.actions.team.IDeleteTeamMember);
    }, [dispatch, team, user]);

    const showOwnerBadge = React.useMemo(() => {
        return !!(team && team.owner_id === user.id);
    }, [team, user]);

    return (
        <ListGroup.Item>
            <div className={styles.container}>
                <span className={styles.content}>
                    {user.username || user.email}
                    {showOwnerBadge && (
                        <>
                            {" "}
                            <Badge variant="primary">Owner</Badge>
                        </>
                    )}
                </span>
                {team &&
                    currUser &&
                    team.owner_id == currUser.id &&
                    currUser.email != user.email && (
                        <Button
                            onClick={onDeletePressed}
                            variant="danger"
                            size="sm"
                        >
                            Delete
                        </Button>
                    )}
            </div>
        </ListGroup.Item>
    );
};

export default TeamUserRow;
